import React, { useState } from "react";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("celsius");

  function convertToF(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }

  function convertToC(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  function fahrenheit() {
    return (props.data.temp * 9) / 5 + 32;
  }

  if (unit === "celsius") {
    return (
      <div className="col-4 m-auto">
        <div className="row g-1 m-2">
          <div className="col-6 m-auto text-end">
            <img
              className="img"
              src={props.data.iconUrl}
              alt={props.data.description}
            />
          </div>
          <div className="col-6 m-auto">
            <div className="card-body p-0">
              <h1 className="select m-auto p-1">
                {Math.round(props.data.temp)}ºC
              </h1>
              <small>Units:</small>
              <span className="unit mt-2">
                {" "}
                C {" "}
                <a className="p-1 m-auto" href="/" onClick={convertToF}>
                  F
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="col-4 m-auto">
        <div className="row g-1 m-2">
          <div className="col-6 m-auto text-end">
            <img
              className="img"
              src={props.data.iconUrl}
              alt={props.data.description}
            />
          </div>
          <div className="col-6 m-auto">
            <div className="card-body p-0">
              <h1 className="select m-auto p-1">
                {Math.round(fahrenheit())}ºF
              </h1>
              <small>Units:</small>
              <span className="unit">
                {" "}
                <a className="p-1 m-auto" href="/" onClick={convertToC}>
                  C
                </a>{" "}
                F
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
